if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCoupons);
} else {
    initProductCoupons();
}

document.addEventListener('shopify:section:load', initProductCoupons);
document.addEventListener('shopify:block:load', initProductCoupons);

// Listen to Shopify pubsub variantChange event if pubsub is loaded
function bindVariantEvents() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
    }
}

bindVariantEvents();
document.addEventListener('DOMContentLoaded', bindVariantEvents);

function handleVariantChange(event) {
    if (event && event.data && event.data.variant && event.data.variant.price) {
        const newPrice = event.data.variant.price;
        document.querySelectorAll('.best-price-box-wrapper[data-product-id]').forEach(el => {
            el.setAttribute('data-product-price', newPrice);
        });
        document.querySelectorAll('.offers-block-section-wrapper[data-product-id]').forEach(el => {
            el.setAttribute('data-product-price', newPrice);
        });
    }
    initProductCoupons();
}

function initProductCoupons() {
    const customCartCoupons = window.customCartCoupons || [];

    // Helper: format money in INR style
    const formatINR = (cents) => {
        const rupees = cents / 100;
        return '₹' + Math.round(rupees).toLocaleString('en-IN');
    };

    // --- Process Best Price Containers ---
    const bestPriceContainers = document.querySelectorAll('.best-price-box-wrapper[data-product-id]');
    bestPriceContainers.forEach(bestPriceContainer => {
        const productId = parseInt(bestPriceContainer.getAttribute('data-product-id'));
        const productPrice = parseInt(bestPriceContainer.getAttribute('data-product-price'));
        const productCollectionsRaw = bestPriceContainer.getAttribute('data-product-collections');
        const collectionIds = (productCollectionsRaw || "").split(',').filter(x => x).map(id => parseInt(id.trim()));

        let bestCoupon = null;
        let maxSavings = 0;

        customCartCoupons.forEach(coupon => {
            if (coupon.applyTo && coupon.applyTo !== 'both' && coupon.applyTo !== 'product') return;

            // 1. Check Exclusions FIRST
            const hasExclusions = (coupon.excludeProductIds && coupon.excludeProductIds.length > 0) || 
                                  (coupon.excludeCollectionIds && coupon.excludeCollectionIds.length > 0);
            if (hasExclusions) {
                if (coupon.excludeProductIds && coupon.excludeProductIds.includes(productId)) return;
                if (coupon.excludeCollectionIds && coupon.excludeCollectionIds.some(id => collectionIds.includes(id))) return;
            }

            // 2. Check Inclusions
            const hasInclusions = (coupon.productIds && coupon.productIds.length > 0) || 
                                  (coupon.collectionIds && coupon.collectionIds.length > 0);
            if (hasInclusions) {
                let isIncluded = false;
                if (coupon.productIds && coupon.productIds.includes(productId)) isIncluded = true;
                if (coupon.collectionIds && coupon.collectionIds.some(id => collectionIds.includes(id))) isIncluded = true;
                if (!isIncluded) return;
            }

            // Single-item best price shouldn't advertise bulk-only discounts (e.g. minQuantity > 1)
            if (coupon.minQuantity && coupon.minQuantity > 1) return;

            // Calculate savings
            let savings = 0;
            if (coupon.type === 'percentage') {
                savings = Math.round(productPrice * (coupon.value / 100));
            } else if (coupon.type === 'fixed') {
                savings = coupon.value;
            }

            if (savings > maxSavings) {
                maxSavings = savings;
                bestCoupon = coupon;
            }
        });

        if (bestCoupon && maxSavings > 0) {
            const templateEl = bestPriceContainer.querySelector('template') || 
                               document.getElementById(bestPriceContainer.id.replace('Best-Price-Box', 'BestPriceTemplate')) ||
                               document.getElementById(bestPriceContainer.id.replace('Best-Price', 'BestPriceTemplate'));
            if (templateEl) {
                const bestPriceFinal = Math.max(0, productPrice - maxSavings);
                let html = templateEl.innerHTML;

                html = html.replace(/{best_price}/g, formatINR(bestPriceFinal))
                           .replace(/{saved_amount}/g, formatINR(maxSavings))
                           .replace(/{coupon_code}/g, bestCoupon.code);

                const mainBox = bestPriceContainer.querySelector('.best-price-main-box');
                if (mainBox) mainBox.innerHTML = html;
                bestPriceContainer.style.display = 'block';
                bestPriceContainer.classList.remove('hidden');
            }
        } else {
            bestPriceContainer.style.display = 'none';
            bestPriceContainer.classList.add('hidden');
        }
    });

    // --- Process Offers Block Containers ---
    const offersContainers = document.querySelectorAll('.offers-block-section-wrapper[data-product-id]');
    offersContainers.forEach(offersContainer => {
        const productId = parseInt(offersContainer.getAttribute('data-product-id'));
        const productPrice = parseInt(offersContainer.getAttribute('data-product-price'));
        const productCollectionsRaw = offersContainer.getAttribute('data-product-collections');
        const collectionIds = (productCollectionsRaw || "").split(',').filter(x => x).map(id => parseInt(id.trim()));

        const eligibleCoupons = [];
        const nonEligibleCoupons = [];

        customCartCoupons.forEach(coupon => {
            if (coupon.applyTo && coupon.applyTo !== 'both' && coupon.applyTo !== 'product') return;

            const hasInclusions = (coupon.productIds && coupon.productIds.length > 0) || 
                                  (coupon.collectionIds && coupon.collectionIds.length > 0);
            const hasExclusions = (coupon.excludeProductIds && coupon.excludeProductIds.length > 0) || 
                                  (coupon.excludeCollectionIds && coupon.excludeCollectionIds.length > 0);

            // 1. Check Exclusions FIRST
            let isExcluded = false;
            if (hasExclusions) {
                if (coupon.excludeProductIds && coupon.excludeProductIds.includes(productId)) {
                    isExcluded = true;
                } else if (coupon.excludeCollectionIds && coupon.excludeCollectionIds.some(id => collectionIds.includes(id))) {
                    isExcluded = true;
                }
            }
            if (isExcluded) { nonEligibleCoupons.push(coupon); return; }

            // 2. Check Inclusions
            let isIncluded = true;
            if (hasInclusions) {
                isIncluded = false;
                if (coupon.productIds && coupon.productIds.includes(productId)) {
                    isIncluded = true;
                } else if (coupon.collectionIds && coupon.collectionIds.some(id => collectionIds.includes(id))) {
                    isIncluded = true;
                }
            }

            if (!isIncluded) {
                nonEligibleCoupons.push(coupon);
            } else {
                eligibleCoupons.push(coupon);
            }
        });

        if (eligibleCoupons.length > 0 || nonEligibleCoupons.length > 0) {
            const templateEl = offersContainer.querySelector('template') || 
                               document.getElementById(offersContainer.id.replace('offers-container', 'OfferCardTemplate'));
            if (templateEl) {
                let cardsHtml = '';
                
                eligibleCoupons.forEach(coupon => {
                    let tabText = '';
                    let savingsText = '';
                    
                    if (coupon.type === 'percentage') {
                        tabText = coupon.value + '% OFF';
                        let discountAmount = Math.round(productPrice * (coupon.value / 100));
                        savingsText = 'Save ₹' + Math.round(discountAmount / 100).toLocaleString('en-IN') + ' on this order';
                    } else {
                        tabText = '₹' + Math.round(coupon.value / 100).toLocaleString('en-IN') + ' OFF';
                        savingsText = 'Save ₹' + Math.round(coupon.value / 100).toLocaleString('en-IN') + ' on this order';
                    }

                    let cardHtml = templateEl.innerHTML;
                    cardHtml = cardHtml.replace(/{tab_text}/g, tabText)
                                       .replace(/{savings_text}/g, savingsText)
                                       .replace(/{code}/g, coupon.code)
                                       .replace(/{desc}/g, coupon.desc || 'Click to copy code')
                                       .replace(/{discount_color}/g, '#0a8a5b');

                    cardsHtml += cardHtml;
                });

                let moreCardsHtml = '';
                if (nonEligibleCoupons.length > 0) {
                    nonEligibleCoupons.forEach(coupon => {
                        let tabText = '';
                        let savingsText = 'Not applicable to this product';
                        
                        if (coupon.type === 'percentage') {
                            tabText = coupon.value + '% OFF';
                        } else {
                            tabText = '₹' + Math.round(coupon.value / 100).toLocaleString('en-IN') + ' OFF';
                        }

                        let cardHtml = templateEl.innerHTML;
                        cardHtml = cardHtml.replace(/{tab_text}/g, tabText)
                                           .replace(/{savings_text}/g, savingsText)
                                           .replace(/{code}/g, coupon.code)
                                           .replace(/{desc}/g, coupon.desc || 'Click to copy code')
                                           .replace(/{discount_color}/g, '#9ca3af');

                        moreCardsHtml += cardHtml;
                    });
                }

                const carousel = offersContainer.querySelector('.offers-carousel');
                if (carousel) carousel.innerHTML = cardsHtml + moreCardsHtml;
                
                // Inject into modal
                const modalId = offersContainer.id.replace('offers-container', 'offers-modal');
                const modal = document.getElementById(modalId);
                if (modal) {
                    const modalGrid = modal.querySelector('.offers-modal-grid');
                    if (modalGrid) {
                        let finalHtml = cardsHtml;
                        if (moreCardsHtml !== '') {
                            finalHtml += '<div style="font-weight: 700; font-size: 14px; color: #333; margin-top: 20px; margin-bottom: 10px; width: 100%;">More offers</div>' + moreCardsHtml;
                        }
                        modalGrid.innerHTML = finalHtml;
                    }
                }

                offersContainer.style.display = 'block';
                offersContainer.classList.remove('hidden');
                
                // Handle View All link logic
                const viewAllBtn = offersContainer.querySelector('.offers-view-all');
                if (viewAllBtn) {
                    if (eligibleCoupons.length + nonEligibleCoupons.length > 1) {
                        viewAllBtn.style.display = 'flex';
                    } else {
                        viewAllBtn.style.display = 'none';
                    }
                }
                
                // Re-bind modal events if needed
                if (typeof window.initOffersBlock === 'function') {
                    window.initOffersBlock();
                }
            }
        } else {
            offersContainer.style.display = 'none';
            offersContainer.classList.add('hidden');
        }
    });
}

window.initProductCoupons = initProductCoupons;

document.addEventListener('product-info:loaded', () => {
    initProductCoupons();
});

try {
    if (typeof MutationObserver !== 'undefined') {
        const couponObserver = new MutationObserver((mutations) => {
        let shouldInit = false;
        for (const mutation of mutations) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                if (mutation.target && mutation.target.matches && mutation.target.matches('quick-add-modal[open], modal-dialog[open]')) {
                    shouldInit = true;
                    break;
                }
            } else if (mutation.type === 'childList') {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === 1) {
                        if (node.matches && (node.matches('.best-price-box-wrapper') || node.matches('quick-add-modal') || node.matches('product-info'))) {
                            shouldInit = true;
                            break;
                        }
                        if (node.querySelector && (node.querySelector('.best-price-box-wrapper') || node.querySelector('.offers-block-section-wrapper'))) {
                            shouldInit = true;
                            break;
                        }
                    }
                }
                if (shouldInit) break;
            }
        }
        if (shouldInit) {
            initProductCoupons();
        }
    });

    if (document.body) {
        couponObserver.observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['open'] });
    } else {
        document.addEventListener('DOMContentLoaded', () => {
            couponObserver.observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['open'] });
        });
    }
    }
} catch (e) {
    console.error('MutationObserver setup failed:', e);
}

console.log('Product coupons script loaded', window.customCartCoupons);

